import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../modals/modal.service';
import { DatosService } from '../../services/datos.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(
    private modal: ModalService,
    private data: DatosService,
    private router: Router
  ) {}

  ngOnInit() {}

  public loadData(): void {
    const datosGuardados = this.getDatosDesdeLocalStorage();
    console.log('Datos obtenidos del localStorage: ', datosGuardados);

    if (datosGuardados.length === 0) {
      console.log('No hay datos guardados en localStorage');
    }

    this.modal.loadScenario(datosGuardados).then((data: any) => {
      if (!data) return;

      if (data._key === 'valor_por_defecto') {
        const defaultData = localStorage.getItem('valor_por_defecto');
        if (defaultData) {
          const parsed = JSON.parse(defaultData);
          this.data.setScenario(parsed);
          console.log('Datos por defecto cargados desde localStorage');
        }
      } else {
        const rawData = localStorage.getItem(data._key);
        if (rawData) {
          const parsed = JSON.parse(rawData);
          this.data.setScenario(parsed);
          console.log(`Datos "${data.name}" cargados desde localStorage`);
        }
      }
    }).catch((error) => {
      console.error('Error al cargar los datos', error);
    });
  }

  mostrarSubmenu = false;
  nombreEscenario = '';

  toggleSubmenu() {
    this.mostrarSubmenu = !this.mostrarSubmenu;
  }

  guardarEnLocalStorage() {
    if (this.nombreEscenario.trim()) {
      const datosPorDefecto = localStorage.getItem('valor_por_defecto');
      
      if (datosPorDefecto) {
        const datosActuales = JSON.parse(datosPorDefecto);
        localStorage.setItem(this.nombreEscenario.trim(), JSON.stringify(datosActuales));
        
        this.mostrarSubmenu = false;
        this.nombreEscenario = '';
        console.log('Escenario guardado con éxito');
        this.cargarListaEscenarios();
      } else {
        console.log('No se encontraron datos de valor_por_defecto para guardar.');
      }
    } else {
      console.log('Nombre inválido');
    }
  }

  private getDatosDesdeLocalStorage(): any[] {
    const datos: any[] = [];
    console.log('Recorriendo localStorage...');

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      console.log(`Clave en el localStorage: ${key}`);

      if (!key || key === 'access_token') continue;

      try {
        const data = JSON.parse(localStorage.getItem(key)!);
        if (data) {
          data._key = key;
          datos.push(data);
        }
      } catch (e) {
        console.warn(`Error al parsear el dato almacenado en "${key}"`, e);
      }
    }

    console.log('Datos obtenidos desde localStorage: ', datos);
    return datos;
  }

  private generarKey(nombre: string): string {
    return `dato_${nombre.trim().toLowerCase().replace(/\s+/g, '_')}`;
  }

  public seleccionarEscenarioGuardado(): string | null {
    const escenarios: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || key === 'access_token' || key === 'valor_por_defecto') continue;
      escenarios.push(key);
    }

    if (escenarios.length === 0) {
      alert('No hay escenarios guardados para cargar.');
      return null;
    }

    const opciones = escenarios.map((k, i) => `${i + 1}. ${k}`).join('\n');
    const seleccion = prompt(`Seleccione un escenario ingresando su número:\n${opciones}`);

    if (!seleccion) return null;

    const index = parseInt(seleccion, 10) - 1;

    if (isNaN(index) || index < 0 || index >= escenarios.length) {
      alert('Selección inválida');
      return null;
    }

    return escenarios[index];
  }

  public seleccionarYLoadEscenario(): void {
    const escenarios: string[] = [];

    if (localStorage.getItem('valor_por_defecto')) {
      escenarios.push('valor_por_defecto');
    }

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || key === 'access_token' || escenarios.includes(key)) continue;
      escenarios.push(key);
    }

    if (escenarios.length === 0) {
      alert('No hay escenarios guardados para cargar.');
      return;
    }

    const opciones = escenarios.map((k, i) => `${i + 1}. ${k}`).join('\n');
    const seleccion = prompt(`Seleccione un escenario para cargar:\n${opciones}`);

    if (!seleccion) return;

    const index = parseInt(seleccion, 10) - 1;

    if (isNaN(index) || index < 0 || index >= escenarios.length) {
      alert('Selección inválida.');
      return;
    }

    const claveSeleccionada = escenarios[index];
    const rawData = localStorage.getItem(claveSeleccionada);

    if (!rawData) {
      alert('No se encontró información para ese escenario.');
      return;
    }

    try {
      const parsed = JSON.parse(rawData);

      if (claveSeleccionada === 'valor_por_defecto') {
        localStorage.setItem('valor_por_defecto', JSON.stringify(parsed));
        window.location.reload();  
        return;  
      }

      localStorage.setItem('valor_por_defecto', JSON.stringify(parsed));
    } catch (e) {
      console.error('Error al parsear el escenario:', e);
      alert('Hubo un error al cargar el escenario.');
    }
  }

  mostrarSubmenuCargar = false;
  escenariosGuardados: string[] = [];

  toggleSubmenuCargar() {
    this.mostrarSubmenuCargar = !this.mostrarSubmenuCargar;
    if (this.mostrarSubmenuCargar) {
      this.cargarListaEscenarios();
    }
  }

  cargarListaEscenarios() {
    const escenarios: string[] = [];

    if (localStorage.getItem('valor_por_defecto')) {
      escenarios.push('valor_por_defecto');
    }

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || key === 'access_token' || escenarios.includes(key)) continue;
      escenarios.push(key);
    }

    this.escenariosGuardados = escenarios;
  }

  cargarEscenario(claveSeleccionada: string) {
    const rawData = localStorage.getItem(claveSeleccionada);

    if (!rawData) {
      console.error('No se encontró información para ese escenario.');
      return;
    }

    try {
      const parsed = JSON.parse(rawData);

      localStorage.setItem('valor_por_defecto', JSON.stringify(parsed));
      console.log(`Escenario "${claveSeleccionada}" cargado como 'valor_por_defecto'.`);

      if (claveSeleccionada === 'valor_por_defecto') {
        window.location.reload();  
      }

      this.mostrarSubmenuCargar = false;
    } catch (e) {
      console.error('Error al parsear el escenario:', e);
    }
  }
}
